<mat-dialog-content>
  <app-vendor-form (createVendor)="createVendor($event)"></app-vendor-form>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="mat-raised-button" (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>